/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Meeting_Notetaker_Issue_Waiting_Room_Body_OrganizerInputs */



/**
* | output |
* | --- |
* | "{name} (organiser) still has to let the notetaker in. It is called \"Wundo\" in the list of people waiting." |
*
* @param {Meeting_Notetaker_Issue_Waiting_Room_Body_OrganizerInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_notetaker_issue_waiting_room_body_organizer = /** @type {((inputs: Meeting_Notetaker_Issue_Waiting_Room_Body_OrganizerInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Notetaker_Issue_Waiting_Room_Body_OrganizerInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ (`${i?.name} (organisator) moet de notetaker nog binnenlaten. Hij heet "Wundo" in de lijst met wachtenden.`)
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.name} (organisateur) doit encore laisser entrer le notetaker. Il s'appelle "Wundo" dans la liste d'attente.`)
	return /** @type {LocalizedString} */ (`${i?.name} (organiser) still has to let the notetaker in. It is called "Wundo" in the list of people waiting.`)
});